/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Public_Writes_DisabledInputs */



/**
* | output |
* | --- |
* | "Public submissions disabled" |
*
* @param {Artifact_Canvas_Public_Writes_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_public_writes_disabled = /** @type {((inputs?: Artifact_Canvas_Public_Writes_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Public_Writes_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffentliche Einreichungen deaktiviert")
	return /** @type {LocalizedString} */ ("Public submissions disabled")
});